// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Help index page */
#helpPage .assignmentsHeader {
  margin-bottom: 45px;
}
#helpPage .row.helpBody {
  margin-right: -22px;
  margin-left: -22px;
}

#helpPage .row.helpBody {
  margin-top: 15px;
}

#helpPage .helpBox {
  padding-left: 7px;
  padding-right: 7px;
}

#helpPage img.icon {
  width: 100px;
  height: 100px;
}

#helpPage .help .col-md-4 .info h3 {
  width: 68%;
}
/* For Demo Videos */
.help .modal-header {
  display: flex;
  justify-content: center;
}

/* Header styling & layout */
#helpStudentPage .assignmentsHeader {
  justify-content: space-between;
}

#helpStudentPage .assignmentsHeader h2 {
  margin-bottom: 0;
}

.help .col-md-4 .icon {
  margin: 25px auto 0;
}

#helpStudentPage .icon.note {
  vertical-align: text-bottom;
  margin-right: 3rem;
  display: inline-block;
  width: 5.5rem;
  height: 5.5rem;
}

#helpStudentPage .assignmentsHeader a {
  font-size: 16px;
}

/* Header styling & layout */
.help .assignmentsHeader {
  justify-content: space-between;
}

.help .assignmentsHeader h2 {
  margin-bottom: 0;
}

.help .col-md-4 .icon {
  margin: 25px auto 0;
}

.help .icon.note {
  vertical-align: text-bottom;
  margin-right: 3rem;
  display: inline-block;
  width: 5.5rem;
  height: 5.5rem;
}

.help .assignmentsHeader a {
  font-size: 16px;
}

.help .col-md-4 .background {
  height: 200px;
  position: relative;
  width: 100%;
}

.help .col-md-4 .info {
  bottom: 0;
  height: 100%;
  position: absolute;
  width: 100%;
}

.help .col-md-4 .info h3 {
  color: #fff;
  margin: 15px auto;
  text-align: center;
  width: 75%;
  font-size: 16px;
  font-weight: bold;
}

.help .col-md-4 .info h3 a {
  color: #fff;
  font-weight: bold;
}

.help .uicontrol {
  font-weight: bold;
}

.help .stepresult {
  text-indent: 1em;
}

.help .info {
  font-style: italic;
}

.helpNav {
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  margin-top: 40px;
  padding-bottom: 30px;
  padding-top: 30px;
}

.taHelpNav {
  border-bottom: 1px solid #ccc;
  margin-top: 40px;
  padding-top: 30px;
  overflow: hidden;
}

.taHelpNav h1 {
  margin-bottom: 30px;
}

.helpNav .col-md-6 {
  width: 50%;
  padding: 0px 15px 7px;
}

.taHelpNav .col-md-6 {
  width: 50%;
  padding: 0px 15px 7px;
}

.helpBody .col-md-12 {
  border-bottom: 1px solid #ccc;
}

.helpBody .col-md-12:last-child {
  margin-bottom: 30px;
}

.helpBody .col-md-12 article {
  margin-top: 30px;
  padding-bottom: 30px;
}

.helpBody .taskbody {
  font-size: 14px;
}

.helpBody h3 {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 30px;
}

.taHelpNav .back-to-top {
  margin-top: 30px !important;
  border-bottom: none !important;
}

.help h2 {
  font-family: Verdana;
  font-size: 24px;
}

.help .taCategory .col-md-12 .title {
  font-size: 24px;
}

#idesign {
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/help/help.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;AACA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Help index page */\n#helpPage .assignmentsHeader {\n  margin-bottom: 45px;\n}\n#helpPage .row.helpBody {\n  margin-right: -22px;\n  margin-left: -22px;\n}\n\n#helpPage .row.helpBody {\n  margin-top: 15px;\n}\n\n#helpPage .helpBox {\n  padding-left: 7px;\n  padding-right: 7px;\n}\n\n#helpPage img.icon {\n  width: 100px;\n  height: 100px;\n}\n\n#helpPage .help .col-md-4 .info h3 {\n  width: 68%;\n}\n/* For Demo Videos */\n.help .modal-header {\n  display: flex;\n  justify-content: center;\n}\n\n/* Header styling & layout */\n#helpStudentPage .assignmentsHeader {\n  justify-content: space-between;\n}\n\n#helpStudentPage .assignmentsHeader h2 {\n  margin-bottom: 0;\n}\n\n.help .col-md-4 .icon {\n  margin: 25px auto 0;\n}\n\n#helpStudentPage .icon.note {\n  vertical-align: text-bottom;\n  margin-right: 3rem;\n  display: inline-block;\n  width: 5.5rem;\n  height: 5.5rem;\n}\n\n#helpStudentPage .assignmentsHeader a {\n  font-size: 16px;\n}\n\n/* Header styling & layout */\n.help .assignmentsHeader {\n  justify-content: space-between;\n}\n\n.help .assignmentsHeader h2 {\n  margin-bottom: 0;\n}\n\n.help .col-md-4 .icon {\n  margin: 25px auto 0;\n}\n\n.help .icon.note {\n  vertical-align: text-bottom;\n  margin-right: 3rem;\n  display: inline-block;\n  width: 5.5rem;\n  height: 5.5rem;\n}\n\n.help .assignmentsHeader a {\n  font-size: 16px;\n}\n\n.help .col-md-4 .background {\n  height: 200px;\n  position: relative;\n  width: 100%;\n}\n\n.help .col-md-4 .info {\n  bottom: 0;\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n\n.help .col-md-4 .info h3 {\n  color: #fff;\n  margin: 15px auto;\n  text-align: center;\n  width: 75%;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.help .col-md-4 .info h3 a {\n  color: #fff;\n  font-weight: bold;\n}\n\n.help .uicontrol {\n  font-weight: bold;\n}\n\n.help .stepresult {\n  text-indent: 1em;\n}\n\n.help .info {\n  font-style: italic;\n}\n\n.helpNav {\n  border-bottom: 1px solid #ccc;\n  border-top: 1px solid #ccc;\n  margin-top: 40px;\n  padding-bottom: 30px;\n  padding-top: 30px;\n}\n\n.taHelpNav {\n  border-bottom: 1px solid #ccc;\n  margin-top: 40px;\n  padding-top: 30px;\n  overflow: hidden;\n}\n\n.taHelpNav h1 {\n  margin-bottom: 30px;\n}\n\n.helpNav .col-md-6 {\n  width: 50%;\n  padding: 0px 15px 7px;\n}\n\n.taHelpNav .col-md-6 {\n  width: 50%;\n  padding: 0px 15px 7px;\n}\n\n.helpBody .col-md-12 {\n  border-bottom: 1px solid #ccc;\n}\n\n.helpBody .col-md-12:last-child {\n  margin-bottom: 30px;\n}\n\n.helpBody .col-md-12 article {\n  margin-top: 30px;\n  padding-bottom: 30px;\n}\n\n.helpBody .taskbody {\n  font-size: 14px;\n}\n\n.helpBody h3 {\n  font-weight: bold;\n  font-size: 16px;\n  margin-bottom: 30px;\n}\n\n.taHelpNav .back-to-top {\n  margin-top: 30px !important;\n  border-bottom: none !important;\n}\n\n.help h2 {\n  font-family: Verdana;\n  font-size: 24px;\n}\n\n.help .taCategory .col-md-12 .title {\n  font-size: 24px;\n}\n\n#idesign {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
